import DeliveryOptionsList from './deliveryOptionsList';

export default DeliveryOptionsList;
